import { CertificateType } from '../enums/certificate-type.enum';

export class Certificate {
  public certificate: string;
  public type: CertificateType;
  public readonly validUntil: Date;

  constructor(backEndCertificate?: BackEndCertificate) {
    if (backEndCertificate) {
      this.certificate = backEndCertificate.certificate;
      this.type = backEndCertificate.type;
      this.validUntil = new Date(backEndCertificate.not_after);
    }
  }

  public toBackEnd(): BackEndCertificate {
    return {
      certificate: this.certificate,
      not_after: this.validUntil ? this.validUntil.toString() : null,
      type: this.type,
    };
  }

}

export interface BackEndCertificate {
  certificate: string;
  not_after: string;
  type: CertificateType;
}
